import React from 'react'
import './Why.css'
import { useTranslation } from 'react-i18next';

const Why = () => {
  const { t } = useTranslation();

  return (
    <section id='why-us'>
      <div className="container-fluid px-md-5 my-5 pt-5 px-3">
        <div className="row">
          <div className="col-md-6">
            <h4 className='section-suptitle'>{t('why.title')}</h4>
            <p className='section-desc w-100 mb-4'>{t('why.desc')}</p>
            <div className="row">
                <div className="col-md-6 ps-2 px-1">
                    <img src="why-1.png" className='img-fluid rounded-3 mb-2' alt="why" />
                    <img src="why-2.png" className='img-fluid rounded-3 mb-2' alt="why" />
                </div>
                <div className="col-md-6 px-1 pe-2">
                    <img src="why-3.png" className='img-fluid rounded-3 mb-2' alt="why" />
                    <img src="why-4.png" className='img-fluid rounded-3 mb-2' alt="why" />
                </div>
            </div>
          </div>
          <div className="col-md-6 ps-md-5">
            <div className="row mt-4">
                <div className="col-md-6 text-center text-md-start">
                    <div className="number shadow mb-4 mx-auto mx-md-0">01</div>
                    <h3 className='number-title mb-4'>{t('why.item1.title')}</h3>
                    <p className='section-desc w-100 mb-4'>{t('why.item1.desc')}</p>
                </div>
                <div className="col-md-6 text-center text-md-start">
                    <div className="number shadow mb-4 mx-auto mx-md-0">02</div>
                    <h3 className='number-title mb-4'>{t('why.item2.title')}</h3>
                    <p className='section-desc w-100 mb-4'>{t('why.item2.desc')}</p>
                </div>
                <div className="col-md-6 text-center text-md-start">
                    <div className="number shadow mb-4 mx-auto mx-md-0">03</div>
                    <h3 className='number-title mb-4'>{t('why.item3.title')}</h3>
                    <p className='section-desc w-100 mb-4'>{t('why.item3.desc')}</p>
                </div>
                <div className="col-md-6 text-center text-md-start">
                    <div className="number shadow mb-4 mx-auto mx-md-0">04</div>
                    <h3 className='number-title mb-4'>{t('why.item4.title')}</h3>
                    <p className='section-desc w-100 mb-4'>{t('why.item4.desc')}</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Why
